export const USER_SURVEY_TITLE_CLASSNAME = 'typo-t3';

export const USER_SURVEY_ANSWER_MIN_LENGTH = 3;
